import React from "react";
import { Helmet } from "react-helmet";
import Header from "./components/header";
import LinkedInComponent from "./components/linkedin";
import AngelListComponent from "./components/angl";
import FlexJobsComponent from "./components/flec";
import IndeedComponent from "./components/indeed";
import NaukriComponent from "./components/nukuri";
import RemoteCoComponent from "./components/remoteco";
import WeWorkRemotelyComponent from "./components/weworkremote";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./components/footer";

function App() {
  return (
    <div>
      {" "}
      <Helmet>
        <title>Find Remote Job Opportunities in India - 2025</title>
        <meta
          name="description"
          content="Discover remote job opportunities from US in india in 2025. Explore platforms find jobs from us,europe canada from india"
        />
        {/* Other SEO-related meta tags can be added here */}
      </Helmet>
      <Header />
      <Container className="mt-4">
        <h1 className="text-center mb-4">
          Exploring Remote Job Opportunities in India 2025
        </h1>
        <Row>
          <Col md={8} className="mx-auto">
            <p>
              In recent years, the concept of remote work has gained substantial
              attention, providing numerous job opportunities for individuals in
              various locations, including India. With the advent of technology
              and the evolution of work culture, many job seekers are now
              exploring remote work options to build their careers.
            </p>

            <p>
              Platforms offering remote job opportunities include:
              <ul>
                <li>
                  <a href="https://www.linkedin.com/">LinkedIn</a>
                </li>
                <li>
                  <a href="https://www.naukri.com/">Naukri.com</a>
                </li>
                <li>
                  <a href="https://www.indeed.com/">Indeed</a>
                </li>
                <li>
                  <a href="https://www.flexjobs.com/">FlexJobs</a>
                </li>
                <li>
                  <a href="https://remote.co/">Remote.co</a>
                </li>
                <li>
                  <a href="https://weworkremotely.com/">We Work Remotely</a>
                </li>
                <li>
                  <a href="https://angel.co/">AngelList</a>
                </li>
                <li>
                  <a href="https://www.upwork.com/">Upwork</a>
                </li>
                <li>
                  <a href="https://www.freelancer.com/">Freelancer</a>
                </li>
              </ul>
            </p>

            <p>
              Overall, the landscape of job hunting has transformed
              significantly, providing an array of remote work possibilities for
              individuals in India and globally.
            </p>

            <p className="text-right font-italic">
              Written by: dev - Date: November 5, 2023
            </p>
          </Col>
        </Row>
        <LinkedInComponent />
        <AngelListComponent />
        <FlexJobsComponent />
        <IndeedComponent />
        <NaukriComponent />
        <RemoteCoComponent />
        <WeWorkRemotelyComponent />
      </Container>
      <Footer />
    </div>
  );
}

export default App;
